export default __webpack_public_path__ + "static/media/g5.ef864822.jpg";